import { FaxConfiguration, FaxConfigurationControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  faxIntegration:FaxConfiguration;
  xTENANTID?: string;
}

export const useUpdateFaxIntegration = () =>
  useMutationWithLoading(async (params: Params) =>
    new FaxConfigurationControllerApi(getConfigObject()).updateConfiguration(
      params.faxIntegration,
      params.xTENANTID
    )
  );
